import {useContext, createContext} from "react";


export const CloseCardContext = createContext<undefined | (() => void)>(undefined);

export function useCloseCard() {
  return useContext(CloseCardContext);
}
